import React from "react";

function CaretLeft() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10.3541 3.35372C10.4006 3.30726 10.4374 3.25211 10.4626 3.19141C10.4877 3.13072 10.5007 3.06566 10.5007 2.99997C10.5007 2.93427 10.4877 2.86921 10.4626 2.80852C10.4374 2.74782 10.4006 2.69267 10.3541 2.64622C10.3077 2.59976 10.2525 2.56291 10.1918 2.53777C10.1311 2.51263 10.0661 2.49969 10.0004 2.49969C9.9347 2.49969 9.86964 2.51263 9.80895 2.53777C9.74825 2.56291 9.6931 2.59976 9.64664 2.64622L4.64664 7.64622C4.60015 7.69265 4.56328 7.7478 4.53811 7.8085C4.51295 7.86919 4.5 7.93426 4.5 7.99997C4.5 8.06567 4.51295 8.13074 4.53811 8.19144C4.56328 8.25214 4.60015 8.30728 4.64664 8.35372L9.64664 13.3537C9.74046 13.4475 9.86771 13.5002 10.0004 13.5002C10.1331 13.5002 10.2603 13.4475 10.3541 13.3537C10.448 13.2599 10.5007 13.1326 10.5007 13C10.5007 12.8673 10.448 12.74 10.3541 12.6462L5.70727 7.99997L10.3541 3.35372Z"
        fill="#3A383F"
      />
    </svg>
  );
}

export default CaretLeft;
